import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [{value: () => import(/* webpackPreload: true */ "./@libs/Leads.js"), path: "./@libs/Leads.js"}];
export const styles = [];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/AdminLeads.store.js"), path: "./@stores/AdminLeads.store.js"}, {value: () => import(/* webpackPreload: true */ "./Modals/LeadDetailModal/@stores/LeadDetailModal.store.js"), path: "./Modals/LeadDetailModal/@stores/LeadDetailModal.store.js"}, {value: () => import(/* webpackPreload: true */ "./Tables/LeadsTable/@stores/LeadsTable.store.js"), path: "./Tables/LeadsTable/@stores/LeadsTable.store.js"}, {value: () => import(/* webpackPreload: true */ "./Tables/PendingLeadsTable/@stores/PendingLeadsTable.store.js"), path: "./Tables/PendingLeadsTable/@stores/PendingLeadsTable.store.js"}];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
